// extracted by mini-css-extract-plugin
module.exports = {"content_container":"Feedback-module--content_container--2Cj1r","main_container":"Feedback-module--main_container--vHKjt"};